const modalControls = (): void => {
  // Inline Links
  const inlineModalTrigger = document.querySelectorAll<HTMLElement>('a');
  inlineModalTrigger.forEach((trigger) => {
    const triggerContent = trigger.textContent;
    const isModalTrigger = triggerContent.includes('[open-modal:');
    if (isModalTrigger) {
      const matches = triggerContent.match(/\[(.*?)\]/);
      const triggerTitle = triggerContent.replace(/\[(.*?)\]/, '');
      const triggerTarget = matches[1].replace('open-modal:', '');
      trigger.classList.add('modal__toggle');
      trigger.innerHTML = triggerTitle;
      trigger.setAttribute('data-modal-target', triggerTarget);
    }
  });

  // HTML Triggers
  const modalTriggers =
    document.querySelectorAll<HTMLElement>('.modal__toggle');
  modalTriggers.forEach((trigger) => {
    if (trigger.hasAttribute('data-modal-target')) {
      const modalTarget = trigger.getAttribute('data-modal-target');
      trigger.addEventListener('click', () => {
        document.body.classList.toggle('modal-' + modalTarget + '--open');
      });
    }
  });
};

export default modalControls;
